const MetricCard = ({ label, value, helper, testId }) => (
  <div className="hud-card clip-corners p-4" data-testid={testId}>
    <p className="text-xs uppercase tracking-[0.3em] text-gray-500">{label}</p>
    <p
      className="mt-2 font-data text-2xl text-white"
      data-testid={`${testId}-value`}
    >
      {value}
    </p>
    {helper && (
      <p className="text-xs text-gray-500" data-testid={`${testId}-helper`}>
        {helper}
      </p>
    )}
  </div>
);

export default MetricCard;
